<template>
  <div>
    <v-container>
      <div class="text-h5">
        Bunt {{ bundle.id }} <span v-if="!bundle.open">Stängd {{ bundle.closedDate|toLocalDate }}</span><span v-else>Öppen</span>
      </div>
      <v-row>
        <v-col cols="12">
          <v-data-table
            class="elevation-1"
            :items="bundle.returnReports"
            :items-per-page="10"
            :hide-default-footer="hidePaging"
            :headers="headers"            
            fixed-header
            mobile-breakpoint="360"
          >
            <template v-slot:item.paper.deliveryDate="{ item }">
              <span>{{ item.paper.deliveryDate | toLocalDate }}</span>
            </template>
            <template v-slot:item.paper.full_name="{item}">
              <span>{{ item.paper.title }}<template v-if="item.paper.type === 1"> {{ item.paper.edition }}</template>                
                <template v-if="item.paper.description"> - {{ item.paper.description }}</template></span>
            </template>
            <template v-slot:item.returnAmount="{item}">
              <span>{{ item.returnAmount }}</span>
            </template>
         
            <template slot="body.append">
              <tr>
                <td>
                  <span>
                    <strong>Totalt</strong>
                  </span>
                </td>
                <td />                              
                <td class="text-right">
                  <span>
                    <strong>{{ total }}</strong>
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table> 
        </v-col>  
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  name:'Bundle',  
  props:{
    bundle:{
      type: Object,
      required: true,
    }
  },
  data() {
    return {      
      headers: [
        { text: 'Datum', sortable: false, value: 'paper.deliveryDate' ,width:'25%' },
        { text: 'Tidning',  align: 'left', value: 'paper.full_name', sortable: false ,width:'50%'},
        { text: 'Returer', align: 'right', value: 'returnAmount', sortable: false }
      ],
      loading: false
    }
  },
  computed: {    
    total() {
      var total = 0
      this.bundle.returnReports.forEach(p => {
        total = total + p.returnAmount
      })
      return total
    },
    hidePaging(){
      return this.bundle.returnReports.length < 10
    }
  },
}
</script>

<style scoped>

</style>
